import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../Actions/userActions';
//import { customerService } from "../Services/CustomerService.js";
import { userService } from "../Services/UserService.js";
import { curriculumService } from "../Services/CurriculumService.js";
import { languageService } from "../Services/LanguageService.js";
import CurriculumForm from "../Components/User/CurriculumForm";
import { withRouter } from 'react-router';
import {denormalizerService} from "../Services/denormalizerService.js";

class CurriculumFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state={
			langPairs: [],
			curriculum: null,
			portrait: null
		};
		this.handleChangeCurriculum = this.handleChangeCurriculum.bind(this);
		this.downloadCV = this.downloadCV.bind(this);
		this.saveCurriculum = this.saveCurriculum.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
		this.downloadPortrait = this.downloadPortrait.bind(this);
		
	}
	
	componentDidMount() {
		languageService.getLangiuagePairs()
			.then(response => {let list=response.data; return this.setState({ langPairs: list.sort(function(a, b) { return (a.code > b.code) ? 1 : ((a.code < b.code) ? -1 : 0);}) });;})
			.then( response => curriculumService.getCurriculum(this.props.curriculumId))
			.then( response => this.setState({curriculum: response.data }))
			.then( response => this.downloadPortrait())
			//.then( response => this.setState({portrait: response }))
			.catch(err => {/*console.log(err);*/});
	}
	
	handleChangeCurriculum(cv){
		//console.log('handleChangeCurriculum: '+JSON.stringify(cv));
		this.setState({curriculum: cv});
	}
	
	downloadCV(id){
		//console.log("Download curriculum "+id);
		let filename="CV_"+id+".pdf";
		curriculumService.getCurriculumDocx(id)
		.then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename); //or any other extension
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
		})
		.catch(err => {/*console.log(err);*/});
	}
	
	async downloadPortrait(){
		if(typeof(this.state.curriculum.portrait) !== "undefined"){
//			console.log("CONTAINER: download protrait: "+this.state.curriculum.portrait.id)
			let resp = await curriculumService.downloadPortrait(this.state.curriculum.portrait.id);
//			console.log(resp);
			this.setState({portrait: resp.data })
			return resp.data;
		}else{
//			console.log("CONTAINER: download protrait: id NULL")
			return null;
		}
	}
	
	saveCurriculum(){
		//console.log("saveCurriculum");
		curriculumService.updateCurriculum(this.state.curriculum)
						.then(response => {return this.props.history.go(-1);})
						.catch(err => {/*console.log(err);*/});
	}
	
	uploadFile(cvId, file){
		return curriculumService.uploadDocument(cvId, file)
			.then( response => curriculumService.getCurriculum(this.props.curriculumId))
			.then( response => this.setState({curriculum: response.data }))
			.catch(err => {/*console.log(err);*/});
	}
	
	uploadPortrait(cvId, file){
		return curriculumService.uploadPortrait(cvId, file)
			.then( response => curriculumService.getCurriculum(this.props.curriculumId))
			.then( response => this.setState({curriculum: response.data }))
			.catch(err => {/*console.log(err);*/});
	}
	
	render() {
//		console.log(this.state);
		var user;
		let newDate = new Date();
				
		if(this.state.curriculum === null){
			return (<div>Loading...</div>);
		}else{
			//if(typeof(this.state.curriculum.portrait) !== "undefined" &&  this.state.portrait!==null && this.state.portrait!==this.state.curriculum.portrait.id){
			//	let resp = curriculumService.downloadPortrait(this.state.curriculum.portrait.id);
			//	this.setState({portrait: resp.data});
			//}
			return (<CurriculumForm	cv={this.state.curriculum}
									handleChangeCurriculum={this.handleChangeCurriculum}
									langPairs={this.state.langPairs}
									downloadCV={this.downloadCV}
									saveCurriculum={this.saveCurriculum}
									accessToken={this.props.user.access_token}
									uploadFile = {this.uploadFile}
									uploadPortrait = {this.uploadPortrait}
									portrait = {this.state.portrait}/>);
		}
	}
}

function mapStateToProps(state, ownProps) {  
	//console.log('mapStateToProps ownProps [CurriculumFormContainer]: '+JSON.stringify(ownProps));
	return {curriculumId: ownProps.match.params.id, user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(userActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(CurriculumFormContainer);  